var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQfLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "v8d5o83feb",
    width: "197.2%",
    height: "197.2%",
    x: "-48.6%",
    y: "-43.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.158387595 0 0 0 0 0.299784887 0 0 0 0 0.530485734 0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "4i0bj1xhba",
    width: 36,
    height: 36,
    x: 0,
    y: 0,
    rx: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -216) translate(29 225)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1umpziphsc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4i0bj1xhba"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#v8d5o83feb)",
    xlinkHref: "#4i0bj1xhba"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#3FB2FF",
    xlinkHref: "#4i0bj1xhba"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M20.855 24.729l-2.275-2.314c.641-.407 1.148-.962 1.521-1.664s.56-1.486.56-2.353c0-.901-.198-1.71-.592-2.425-.395-.715-.936-1.271-1.625-1.67-.69-.399-1.459-.598-2.308-.598-.858 0-1.631.2-2.32.598-.69.399-1.233.955-1.632 1.67-.399.716-.598 1.524-.598 2.425 0 .901.2 1.71.598 2.425.399.715.943 1.273 1.632 1.677.689.402 1.462.604 2.32.604.433 0 .85-.052 1.248-.156l1.638 1.781h1.833zm-4.719-3.016c-.59 0-1.114-.134-1.573-.403-.46-.269-.817-.654-1.072-1.157-.256-.503-.384-1.088-.384-1.755 0-.667.128-1.252.384-1.755.255-.503.613-.888 1.072-1.157.46-.269.984-.403 1.573-.403.58 0 1.099.134 1.554.403.455.269.81.654 1.066 1.157.255.503.383 1.088.383 1.755 0 .667-.128 1.252-.383 1.755-.256.503-.611.888-1.066 1.157-.455.269-.973.403-1.554.403zM23.532 23v-5.889h1.573v-1.274h-1.573v-.117c0-.511.116-.873.35-1.086.234-.212.642-.305 1.223-.279v-1.3c-1.023-.052-1.79.14-2.302.579-.51.437-.767 1.094-.767 1.969v.234h-.975v1.274h.976V23h1.495z",
    mask: "url(#1umpziphsc)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQfLogo);
export default __webpack_public_path__ + "static/media/QF-logo.edbb6769853bdcfecdf4107edfa9a868.svg";
export { ForwardRef as ReactComponent };